export const datesFieldStyles = {
  wrapper: { alignItems: 'center !important' },
};
